import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { VISA_TYPE } from '@interfaces';
import moment from 'moment-timezone';

@Component({
  selector: 'app-partial-stay-visa',
  templateUrl: './partial-stay-visa.component.html',
  styleUrls: ['./partial-stay-visa.component.scss'],
  standalone: false,
})
export class PartialStayVisaComponent {
  @Input() controls: { [key: string]: FormControl };
  @Input() minValidDate: moment.Moment;
  @Input() maxValidDate: moment.Moment;
  @Input() maxValidFutureDate: moment.Moment;
  @Input() documentIssuePickerStartDate: moment.Moment;
  @Input() documentExpiryPickerStartDate: moment.Moment;
  @Input() visaTypes: VISA_TYPE[];
}
